const solutionData = [
  {
    id: 'ai-voice-automation',
    title: 'AI Voice Automation for Business',
    summary: 'Explore tailored voice workflows for customer calls, lead qualification, reminders, and support, based on a modular Bularis Tech engineering project.',
    homepageSummary: 'Adapt AI voice workflows to your customer conversations, telephony environment, and business processes, subject to technical validation.',
    path: '/solutions/ai-voice-automation',
  },
  {
    id: 'jazzcash-payment-gateway-integration',
    title: 'JazzCash Payment Gateway Integration',
    summary: 'Connect JazzCash payment capabilities to your website or application using merchant-provided, authorized credentials.',
    homepageSummary: 'Connect online payment flows with the websites, orders, bookings, or business systems that need reliable payment-status handling.',
    path: '/solutions/jazzcash-payment-gateway-integration',
  },
];

export default solutionData;
